import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="bg-white min-h-screen font-sans text-[#7a7a7a]">
      
      {/* Header / Breadcrumb Section with #ffdfef color */}
      <div className="relative h-44 bg-[#ffdfef] flex flex-col items-center justify-center">
        <h1 className="text-2xl md:text-3xl font-bold text-black uppercase tracking-[0.2em]">
          Privacy Policy
        </h1>
        <div className="text-[12px] mt-3 text-gray-600 uppercase tracking-widest">
          Home <span className="mx-2 text-gray-400">/</span> Privacy Policy
        </div>
      </div>

      {/* Main Content Area - Now on white background */}
      <div className="max-w-5xl mx-auto px-6 py-16 md:py-24">
        <div className="space-y-12">
          
          {/* Section 1 */}
          <section className="space-y-4">
            <h2 className="text-black font-bold text-lg uppercase tracking-tight border-b border-gray-100 pb-2">
              1. Information We Collect
            </h2>
            <p className="text-[14.5px] leading-[1.8] text-justify">
              We collect information to provide better services to all our users. This includes information you provide to us, like your email address or name when you sign up for our newsletter or contact us through our digital platform. We ensure that all data collected is handled with the utmost care and in compliance with global data protection standards.
            </p>
          </section>

          {/* Section 2: Bullet Points */}
          <section className="space-y-4">
            <h2 className="text-black font-bold text-lg uppercase tracking-tight border-b border-gray-100 pb-2">
              2. How We Use Information
            </h2>
            <p className="text-[14.5px] leading-[1.8] mb-4">
              We use the information we collect from all our services for the following purposes:
            </p>
            <ul className="space-y-3 pl-2">
              {[
                'To provide, maintain, and improve our services.',
                'To develop new services and features for our healthcare community.',
                'To protect our users and the public from security threats.',
                'To communicate with you regarding updates or support requests.'
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-3 text-[14px]">
                  <span className="mt-2 w-1.5 h-1.5 bg-gray-300 rounded-full flex-shrink-0"></span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>

          {/* Section 3 */}
          <section className="space-y-4">
            <h2 className="text-black font-bold text-lg uppercase tracking-tight border-b border-gray-100 pb-2">
              3. Data Security
            </h2>
            <p className="text-[14.5px] leading-[1.8] text-justify">
              Security is our top priority. We work hard to protect our users from unauthorized access to or unauthorized alteration, disclosure, or destruction of information we hold. We restrict access to personal information to employees, contractors, and agents who need that information in order to process it.
            </p>
          </section>

          {/* Section 4: Contact Highlight */}
          <div className="mt-16 p-8 bg-gray-50 rounded-sm border-l-4 border-black/10">
            <h3 className="text-black font-bold uppercase text-sm mb-2">Questions about our policy?</h3>
            <p className="text-[14px]">
              If you have any questions regarding this Privacy Policy, you can contact us at: 
              <span className="text-black font-semibold ml-1 cursor-pointer hover:underline">support@simplekindness.com</span>
            </p>
          </div>
        </div>

        {/* Last Updated Date */}
        <div className="mt-20 pt-8 border-t border-gray-100 text-[12px] text-gray-400 italic text-center">
          Last Updated: May 30, 2026
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;